import { Popover } from 'antd';
import React from 'react';
import { FC, useEffect, useState } from 'react';
import headIcon from '../../images/components/miniProgress/head.svg';
import tailIcon from '../../images/components/miniProgress/tail.svg';
import { MinProgressWrap, FishboneView, FishbonePopView } from './style';
//迷你进度 条
interface ChildTs {
  id: string;
  entity?: { progressStatus: string };
  sort:number;
}

interface Props {
  progressId: string;
  ajaxGet?: (id: string) => Promise<void | { childNode: ChildTs[] | null }>;
}

/**
 * @param progressId: string 进度ID 
 * @returns 
 */
export const MiniProgress: FC<Props> = ({ progressId, ajaxGet }) => {
  const [allData, setAllData] = useState<ChildTs[]>([]); // 数据
  useEffect(() => {
    getFishboneData(progressId);
  }, [progressId]);
  
  const getFishboneData: (id: string) => Promise<void> = async id => {
    if (ajaxGet) {
      try {
        const body = await ajaxGet(id);
        if (body&&body.childNode?.length) {
          setAllData(sortFishboneAllData(body.childNode) || []);
        }
      } catch (e) {}
    }
  };
  const sortFishboneAllData: (list: ChildTs[]) => ChildTs[] = (list) => {
    //对数据进行排序操作，后端并不会对sort进行任何操作
    list.sort((a, b) => {
      const aSort = a.sort || 0;
      const bSort = b.sort || 0;
      return aSort - bSort;
    });
    return list;
  };
  const stateColor: { [key: string]: string } = {
    PENDING: '#7bb5ff',
    DOING: '#ffb656',
    PAUSED: '#ffb656',
    FINISHED: '#3ab280',
  };
  const renderMain = (minWidth: number, zoom?: number, maxLen?: number) => {
    return (
      <FishboneView minWidth={minWidth} zoom={zoom}>
        <img src={tailIcon}></img>
        <div className="line">
          {allData.slice(0, maxLen || allData.length).map(item => (
            <div
              key={item.id}
              style={{
                backgroundColor: stateColor[item.entity?.progressStatus || ''],
              }}
            ></div>
          ))}
        </div>
        <img src={headIcon}></img>
      </FishboneView>
    );
  };
  return (
    <Popover
      placement="bottom"
      content={<FishbonePopView>{renderMain(500)}</FishbonePopView>}
      trigger="click"
    >
      <MinProgressWrap>{renderMain(200, 40, 9)}</MinProgressWrap>
    </Popover>
  );
};